// torre-cargas · Filiais + Dash Filial + WHP + Baixas + Chegando + Rotas SP
import {
  initAuth, getAuthContext, signInWithGoogle, signInWithMagicLink,
  applyTheme, createOrbitBackground,
  fetchJson, fmtBR, fmtBRL, fmtPct, fmtDate, fmtDateTime, escapeHtml, downloadCsv
} from '@zzyonbr/torre-shared';

const $ = sel => document.querySelector(sel);
const $$ = sel => Array.from(document.querySelectorAll(sel));

// ============================================================
// BOOT
// ============================================================
async function bootstrap() {
  await initAuth();
  const ctx = await getAuthContext();
  applyTheme(ctx.tenant?.branding || {});
  if (!ctx.user) { renderLogin(); return; }
  renderShell(ctx);
  setActiveTab(location.hash.slice(1) || 'filiais');
  window.addEventListener('hashchange', () => setActiveTab(location.hash.slice(1) || 'filiais'));
}

// ============================================================
// LOGIN
// ============================================================
function renderLogin() {
  $('#app').innerHTML = `
    <div class="zzy-fade-up" style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;position:relative;overflow:hidden">
      <div id="orbit-host" style="position:absolute;inset:0;pointer-events:none"></div>
      <div class="zzy-card" style="max-width:440px;width:100%;text-align:center;padding:48px 36px">
        <div style="display:flex;justify-content:center;margin-bottom:28px">
          <zzy-logo size="56" sub="true"></zzy-logo>
        </div>
        <div style="font:400 13px/1.4 var(--zzy-font);color:var(--zzy-text-mute);font-style:italic;margin-bottom:32px">Inteligência em órbita</div>
        <div style="height:1px;background:var(--zzy-border);margin:0 -36px 28px -36px"></div>
        <div class="zzy-eyebrow" style="margin-bottom:8px">Torre de Controle</div>
        <div class="zzy-h3" style="margin-bottom:28px">Cargas</div>
        <button id="login-google" class="zzy-btn" style="width:100%;background:#FFFFFF;color:#1F1F1F;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:12px">
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Entrar com Google
        </button>
        <div style="display:flex;align-items:center;gap:10px;margin:14px 0;color:var(--zzy-text-mute);font:400 11px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.1em">
          <span style="flex:1;height:1px;background:var(--zzy-border)"></span>ou<span style="flex:1;height:1px;background:var(--zzy-border)"></span>
        </div>
        <input id="email" type="email" placeholder="seu.email@empresa.com" class="zzy-input" style="margin-bottom:12px" />
        <button id="login-btn" class="zzy-btn zzy-btn--ghost" style="width:100%">Receber Magic Link por email</button>
        <div id="login-msg" style="margin-top:14px;font:400 12px/1.4 var(--zzy-font);color:var(--zzy-text-mute);min-height:18px"></div>
      </div>
    </div>
  `;
  $('#orbit-host')?.appendChild(createOrbitBackground());
  $('#login-google').addEventListener('click', () => signInWithGoogle(location.origin).catch(e => $('#login-msg').textContent = 'Erro: ' + e.message));
  $('#login-btn').addEventListener('click', async () => {
    const email = $('#email').value.trim();
    if (!email) { $('#login-msg').textContent = 'Informe um email'; return; }
    try {
      await signInWithMagicLink(email, location.origin);
      $('#login-msg').textContent = 'Link enviado!';
      $('#login-msg').style.color = 'var(--zzy-success)';
    } catch (err) {
      $('#login-msg').textContent = 'Erro: ' + err.message;
      $('#login-msg').style.color = 'var(--zzy-danger)';
    }
  });
}

// ============================================================
// SHELL
// ============================================================
function renderShell(ctx) {
  $('#app').innerHTML = `
    <zzy-toast></zzy-toast>
    <zzy-header module="Cargas"></zzy-header>
    <main style="max-width:1500px;margin:0 auto;padding:24px">
      <nav id="tabs" style="display:flex;gap:8px;margin-bottom:20px;border-bottom:1px solid var(--zzy-border);padding-bottom:0;overflow-x:auto">
        <button data-tab="filiais"     class="cg-tab cg-tab--active">Filiais</button>
        <button data-tab="dash-filial" class="cg-tab">Dashboard Filial</button>
        <button data-tab="whp"         class="cg-tab">WHP</button>
        <button data-tab="baixas"      class="cg-tab">Baixas</button>
        <button data-tab="chegando"    class="cg-tab">Chegando</button>
        <button data-tab="rotas-sp"    class="cg-tab">Rotas SP</button>
      </nav>
      <section id="content"></section>
    </main>
    <style>
      .cg-tab { background:transparent;border:0;color:var(--zzy-text-mute);padding:10px 18px;font:500 13px/1 var(--zzy-font);cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1px;transition:color .15s,border-color .15s;white-space:nowrap; }
      .cg-tab:hover { color:var(--zzy-mist); }
      .cg-tab--active { color:var(--zzy-sky);border-bottom-color:var(--zzy-sky); }
      .cg-stat { display:flex;gap:12px;flex-wrap:wrap;margin-bottom:20px; }
      .cg-filter-bar { display:flex;gap:12px;flex-wrap:wrap;align-items:end;margin-bottom:16px; }
      .cg-filter { display:flex;flex-direction:column;gap:4px; }
      .cg-filter label { font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em; }
      .cg-filter select, .cg-filter input { background:rgba(255,255,255,.03);border:1px solid var(--zzy-border);color:var(--zzy-mist);padding:8px 10px;border-radius:6px;font:400 13px/1 var(--zzy-font);min-width:140px;outline:none; }
      .cg-filter input:focus, .cg-filter select:focus { border-color:var(--zzy-sky); }
      .cg-table { width:100%;border-collapse:collapse;font-size:12.5px; }
      .cg-table th { text-align:left;color:var(--zzy-text-mute);font:600 10px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.08em;padding:10px 12px;border-bottom:1px solid var(--zzy-border);position:sticky;top:0;background:var(--zzy-surface-solid); }
      .cg-table td { padding:10px 12px;border-bottom:1px solid var(--zzy-border);vertical-align:top; }
      .cg-table tr:hover td { background:rgba(255,255,255,.02); }
      .cg-badge { display:inline-block;padding:2px 8px;border-radius:4px;font:600 10px/1.4 var(--zzy-font);text-transform:uppercase;letter-spacing:.04em; }
      .cg-badge--ok    { background:rgba(34,197,94,.15);color:var(--zzy-success); }
      .cg-badge--warn  { background:rgba(245,158,11,.15);color:var(--zzy-warning); }
      .cg-badge--late  { background:rgba(239,68,68,.15);color:var(--zzy-danger); }
      .cg-badge--info  { background:rgba(59,110,255,.15);color:var(--zzy-sky); }
    </style>
  `;
  $$('.cg-tab').forEach(b => b.addEventListener('click', () => {
    location.hash = b.dataset.tab;
    setActiveTab(b.dataset.tab);
  }));
}

function setActiveTab(name) {
  $$('.cg-tab').forEach(b => b.classList.toggle('cg-tab--active', b.dataset.tab === name));
  if (name === 'filiais')     loadFiliais();
  if (name === 'dash-filial') loadDashFilial();
  if (name === 'whp')         loadWHP();
  if (name === 'baixas')      loadBaixas();
  if (name === 'chegando')    loadChegando();
  if (name === 'rotas-sp')    loadRotasSP();
}

// ============================================================
// ABA · CONTROLADORIA — DRE Live + Pareto + Leak Detector
// ============================================================
async function loadControladoria() {
  $('#content').innerHTML = `<zzy-spinner>Carregando Controladoria Live (margens ESL/api/report/freight/margins)…</zzy-spinner>`;
  try {
    // Pull paralelo de 4 fontes
    const [dreFilial, dreConsol, pareto, leak, rotas] = await Promise.all([
      fetchJson('/vw_dre_diario_filial?dia=gte.' + new Date(Date.now() - 30*86400000).toISOString().slice(0,10) + '&order=dia.desc,receita_R%24.desc&limit=200'),
      fetchJson('/vw_dre_diario_consolidado?dia=gte.' + new Date(Date.now() - 30*86400000).toISOString().slice(0,10) + '&order=dia.desc&limit=30'),
      fetchJson('/vw_concentracao_pareto?limit=20'),
      fetchJson('/vw_leak_detector?order=margem_pct.asc&limit=30'),
      fetchJson('/vw_margem_por_rota?order=volume_fretes.desc&limit=15'),
    ]);
    renderControladoria({ dreFilial, dreConsol, pareto, leak, rotas });
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

function renderControladoria({ dreFilial, dreConsol, pareto, leak, rotas }) {
  // Agregação 30 dias
  const totReceita = dreConsol.reduce((s,r) => s + Number(r.receita_R$ || r['receita_r$'] || 0), 0);
  const totCusto   = dreConsol.reduce((s,r) => s + Number(r.custo_total_R$ || r['custo_total_r$'] || 0), 0);
  const totMargem  = dreConsol.reduce((s,r) => s + Number(r.margem_R$ || r['margem_r$'] || 0), 0);
  const totFretes  = dreConsol.reduce((s,r) => s + Number(r.volume_fretes || 0), 0);
  const totPrejuizo= dreConsol.reduce((s,r) => s + Number(r.fretes_prejuizo || 0), 0);
  const margemPct  = totReceita > 0 ? (totMargem / totReceita * 100) : 0;
  const pctPrejuizo= totFretes > 0 ? (totPrejuizo / totFretes * 100) : 0;

  // Hoje (último dia)
  const hojeRow = dreConsol[0] || {};
  const hojeReceita = Number(hojeRow.receita_R$ || hojeRow['receita_r$'] || 0);
  const hojeMargem  = Number(hojeRow.margem_R$ || hojeRow['margem_r$'] || 0);
  const hojeFretes  = Number(hojeRow.volume_fretes || 0);

  $('#content').innerHTML = `
    <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ ZZYON Controladoria · Tempo Real (ESL → ZZYON cron 4×/dia)</div>
    <div class="zzy-h3" style="margin-bottom:20px">DRE Live — últimos 30 dias</div>

    <!-- KPIs principais -->
    <div class="cg-stat" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:14px;margin-bottom:24px">
      <div class="zzy-card" style="padding:18px">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Receita 30d</div>
        <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-mist)">${fmtBRL(totReceita)}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${totFretes} fretes</div>
      </div>
      <div class="zzy-card" style="padding:18px">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Custo 30d</div>
        <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-warning)">${fmtBRL(totCusto)}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${(totCusto/totReceita*100||0).toFixed(1)}% da receita</div>
      </div>
      <div class="zzy-card" style="padding:18px;border:1px solid ${margemPct >= 25 ? 'var(--zzy-success)' : 'var(--zzy-warning)'}">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Margem 30d</div>
        <div style="font:700 22px/1 var(--zzy-font);color:${margemPct >= 25 ? 'var(--zzy-success)' : 'var(--zzy-warning)'}">${fmtBRL(totMargem)}</div>
        <div style="font:600 13px/1 var(--zzy-font);color:${margemPct >= 25 ? 'var(--zzy-success)' : 'var(--zzy-warning)'};margin-top:6px">${margemPct.toFixed(2)}% · ${margemPct >= 25 ? 'OK' : 'ABAIXO ALVO 25%'}</div>
      </div>
      <div class="zzy-card" style="padding:18px;border:1px solid ${pctPrejuizo > 5 ? 'var(--zzy-danger)' : 'var(--zzy-border)'}">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Fretes em prejuízo</div>
        <div style="font:700 22px/1 var(--zzy-font);color:${pctPrejuizo > 5 ? 'var(--zzy-danger)' : 'var(--zzy-mist)'}">${totPrejuizo}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${pctPrejuizo.toFixed(1)}% dos fretes</div>
      </div>
      <div class="zzy-card" style="padding:18px">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Hoje (${hojeRow.dia || '—'})</div>
        <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-sky)">${fmtBRL(hojeReceita)}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${hojeFretes} fretes · margem ${fmtBRL(hojeMargem)}</div>
      </div>
    </div>

    <!-- Pareto Top 20 Clientes -->
    <div class="zzy-card" style="padding:24px;margin-bottom:20px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
        <div class="zzy-h4">Pareto · Concentração de Receita por Cliente (30d)</div>
        <button id="cg-export-pareto" class="zzy-btn zzy-btn--ghost" style="font-size:11px;padding:6px 12px">Exportar CSV</button>
      </div>
      <table class="cg-table">
        <thead><tr>
          <th>#</th><th>Cliente</th><th style="text-align:right">Volume</th>
          <th style="text-align:right">Receita</th><th style="text-align:right">Margem R$</th>
          <th style="text-align:right">Margem %</th><th style="text-align:right">% Receita</th>
          <th style="text-align:right">% Acum.</th>
        </tr></thead>
        <tbody>
          ${pareto.map(p => {
            const margemPct = (Number(p.receita_R$ || p['receita_r$']) > 0 ?
              (Number(p.margem_R$ || p['margem_r$']) / Number(p.receita_R$ || p['receita_r$']) * 100) : 0);
            const isWarn = margemPct < 25 && margemPct >= 0;
            const isCrit = margemPct < 0;
            return `
            <tr>
              <td>${p.rank}</td>
              <td><strong>${escapeHtml(p.cliente || '?')}</strong></td>
              <td style="text-align:right">${p.volume}</td>
              <td style="text-align:right;font-weight:600">${fmtBRL(Number(p.receita_R$ || p['receita_r$']))}</td>
              <td style="text-align:right;color:${isCrit ? 'var(--zzy-danger)' : 'inherit'}">${fmtBRL(Number(p.margem_R$ || p['margem_r$']))}</td>
              <td style="text-align:right;color:${isCrit ? 'var(--zzy-danger)' : isWarn ? 'var(--zzy-warning)' : 'var(--zzy-success)'};font-weight:600">${margemPct.toFixed(2)}%</td>
              <td style="text-align:right">${p.pct_receita}%</td>
              <td style="text-align:right;color:var(--zzy-text-mute)">${p.pct_acumulado}%</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>

    <!-- DRE por Filial -->
    <div class="zzy-card" style="padding:24px;margin-bottom:20px">
      <div class="zzy-h4" style="margin-bottom:14px">DRE Diário por Filial</div>
      <table class="cg-table">
        <thead><tr>
          <th>Dia</th><th>Filial</th><th style="text-align:right">Vol.</th>
          <th style="text-align:right">Receita</th><th style="text-align:right">Custo</th>
          <th style="text-align:right">Margem R$</th><th style="text-align:right">Margem %</th>
          <th style="text-align:right">Prejuízo</th>
        </tr></thead>
        <tbody>
          ${dreFilial.slice(0, 50).map(r => {
            const m = Number(r['margem_pct'] || 0);
            return `
            <tr>
              <td>${r.dia}</td>
              <td>${escapeHtml(r.filial || '?')}</td>
              <td style="text-align:right">${r.volume_fretes}</td>
              <td style="text-align:right;font-weight:600">${fmtBRL(Number(r['receita_r$']))}</td>
              <td style="text-align:right;color:var(--zzy-warning)">${fmtBRL(Number(r['custo_total_r$']))}</td>
              <td style="text-align:right">${fmtBRL(Number(r['margem_r$']))}</td>
              <td style="text-align:right;color:${m >= 25 ? 'var(--zzy-success)' : m > 0 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'};font-weight:600">${m ? m.toFixed(2) + '%' : '—'}</td>
              <td style="text-align:right;color:${(r.fretes_prejuizo || 0) > 0 ? 'var(--zzy-danger)' : 'var(--zzy-text-mute)'}">${r.fretes_prejuizo || 0}</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>

    <!-- Leak Detector -->
    <div class="zzy-card" style="padding:24px;margin-bottom:20px;border:1px solid ${leak.length > 50 ? 'var(--zzy-danger)' : 'var(--zzy-border)'}">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
        <div class="zzy-h4">⚠️ Leak Detector — Fretes em prejuízo ou margem &lt; P25 (30d)</div>
        <span class="cg-badge cg-badge--late">${leak.length} alertas</span>
      </div>
      <table class="cg-table">
        <thead><tr>
          <th>Dia</th><th>Filial</th><th>CT-e</th><th>Cliente</th>
          <th>Origem→Destino</th><th style="text-align:right">Receita</th>
          <th style="text-align:right">Custo</th><th style="text-align:right">Margem R$</th>
          <th style="text-align:right">Margem %</th><th>Classif.</th><th style="text-align:right">Z-score</th>
        </tr></thead>
        <tbody>
          ${leak.map(l => {
            const cls = l.classificacao;
            const cor = cls === 'PREJUIZO' ? 'var(--zzy-danger)' : cls === 'OUTLIER_P10' ? 'var(--zzy-warning)' : 'var(--zzy-text-mute)';
            return `
            <tr>
              <td>${l.dia}</td>
              <td style="font-size:11px">${escapeHtml(l.filial || '?')}</td>
              <td style="font-family:monospace;font-size:11px">${escapeHtml(l.cte_number || '—')}</td>
              <td>${escapeHtml((l.cliente || '?').slice(0, 25))}</td>
              <td style="font-size:11px">${escapeHtml(l.origem || '?')} → ${escapeHtml(l.destino || '?')}</td>
              <td style="text-align:right">${fmtBRL(Number(l['receita_r$']))}</td>
              <td style="text-align:right;color:var(--zzy-warning)">${fmtBRL(Number(l['custo_r$']))}</td>
              <td style="text-align:right;color:${Number(l['margem_r$']) < 0 ? 'var(--zzy-danger)' : 'inherit'};font-weight:600">${fmtBRL(Number(l['margem_r$']))}</td>
              <td style="text-align:right;color:${Number(l.margem_pct) < 0 ? 'var(--zzy-danger)' : 'var(--zzy-warning)'};font-weight:600">${Number(l.margem_pct).toFixed(2)}%</td>
              <td><span class="cg-badge" style="background:${cor};color:white">${cls}</span></td>
              <td style="text-align:right;font-family:monospace;color:${Math.abs(Number(l.z_score) || 0) > 2 ? 'var(--zzy-danger)' : 'var(--zzy-text-mute)'}">${l.z_score || '—'}</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>

    <!-- Margem por Rota -->
    <div class="zzy-card" style="padding:24px">
      <div class="zzy-h4" style="margin-bottom:14px">Margem por Rota — Top 15 mais movimentadas (30d)</div>
      <table class="cg-table">
        <thead><tr>
          <th>Origem</th><th>Destino</th><th style="text-align:right">Volume</th>
          <th style="text-align:right">Receita</th><th style="text-align:right">Margem R$</th>
          <th style="text-align:right">Margem %</th><th style="text-align:right">Peso médio</th>
          <th style="text-align:right">Prejuízo</th>
        </tr></thead>
        <tbody>
          ${rotas.map(r => {
            const m = Number(r.margem_pct_media || 0);
            return `
            <tr>
              <td>${escapeHtml(r.origem || '?')}</td>
              <td>${escapeHtml(r.destino || '?')}</td>
              <td style="text-align:right">${r.volume_fretes}</td>
              <td style="text-align:right;font-weight:600">${fmtBRL(Number(r['receita_r$']))}</td>
              <td style="text-align:right">${fmtBRL(Number(r['margem_r$_total']))}</td>
              <td style="text-align:right;color:${m >= 25 ? 'var(--zzy-success)' : m > 0 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'};font-weight:600">${m.toFixed(2)}%</td>
              <td style="text-align:right">${Number(r.peso_medio_kg || 0).toFixed(1)} kg</td>
              <td style="text-align:right;color:${(r.fretes_prejuizo||0)>0?'var(--zzy-danger)':'var(--zzy-text-mute)'}">${r.fretes_prejuizo || 0}</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>
  `;

  $('#cg-export-pareto')?.addEventListener('click', () => {
    downloadCsv('pareto_clientes.csv', pareto);
  });
}

// ============================================================
// ABA · FILIAIS — tabela 2820 linhas + filtros
// ============================================================
let _allFiliais = [];
async function loadFiliais() {
  $('#content').innerHTML = `<zzy-spinner>Carregando filiais (vw_radar_atendente — 1.5k+ fretes em aberto)…</zzy-spinner>`;
  try {
    // Fonte canônica do Torre original — fretes em aberto enriquecidos
    _allFiliais = await fetchJson('/vw_radar_atendente?select=awb,nf_cliente,cte_terceiro,pagador,destinatario,destino_cidade,destino_uf,regiao,quem_entrega_real,agente_entrega,transportadora,data_frete_icaro,previsao_entrega,prazo_sla_dias,status,status_descricao,status_previsao,dias_vencido,dias_em_aberto,em_rota,prioridade,proxima_acao,tentativas_entrega,sem_justificativa_abone,atendente,peso_taxado,volumes,valor_nf,total_frete&limit=5000');
    renderFiliais();
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

function renderFiliais() {
  // Helpers para mapear campos da view (filial canônica = quem_entrega_real, fallback agente_entrega)
  const filialOf = r => r.quem_entrega_real || r.agente_entrega || '(sem filial)';
  const isVencido = r => r.status_previsao === 'VENCIDO' || (r.dias_vencido || 0) > 0;

  const filFilial = $('#f-filial')?.value || '';
  const filPrio   = $('#f-prio')?.value || '';
  const filQ      = ($('#f-q')?.value || '').toLowerCase().trim();
  const filiais   = Array.from(new Set(_allFiliais.map(filialOf).filter(Boolean))).sort();

  const rows = _allFiliais.filter(r => {
    if (filFilial && filialOf(r) !== filFilial) return false;
    if (filPrio && r.prioridade !== filPrio) return false;
    if (filQ) {
      const hay = [r.awb, r.nf_cliente, r.cte_terceiro, r.pagador, r.destinatario, r.destino_cidade, r.destino_uf, r.regiao, r.atendente, filialOf(r)].filter(Boolean).join(' ').toLowerCase();
      if (!hay.includes(filQ)) return false;
    }
    return true;
  });

  const totalCte    = rows.length;
  const vencidos    = rows.filter(isVencido).length;
  const emRota      = rows.filter(r => r.em_rota === 'SIM').length;
  const criticos    = rows.filter(r => r.prioridade === 'CRITICO').length;
  const semJust     = rows.filter(r => r.sem_justificativa_abone).length;

  $('#content').innerHTML = `
    <div class="cg-stat">
      <zzy-stat-card label="Total CT-es/AWBs" value="${fmtBR(totalCte)}" color="primary"></zzy-stat-card>
      <zzy-stat-card label="Vencidos" value="${fmtBR(vencidos)}" color="danger"></zzy-stat-card>
      <zzy-stat-card label="Em rota" value="${fmtBR(emRota)}" color="info"></zzy-stat-card>
      <zzy-stat-card label="Críticos" value="${fmtBR(criticos)}" color="danger"></zzy-stat-card>
      <zzy-stat-card label="Sem justific. (abone)" value="${fmtBR(semJust)}" color="warning"></zzy-stat-card>
    </div>
    <div class="zzy-card" style="margin-bottom:16px">
      <div class="cg-filter-bar">
        <div class="cg-filter">
          <label>Filial</label>
          <select id="f-filial">
            <option value="">Todas</option>
            ${filiais.map(f => `<option value="${escapeHtml(f)}" ${f===filFilial?'selected':''}>${escapeHtml(f)}</option>`).join('')}
          </select>
        </div>
        <div class="cg-filter">
          <label>Prioridade</label>
          <select id="f-prio">
            <option value="">Todas</option>
            <option value="CRITICO"  ${filPrio==='CRITICO'?'selected':''}>CRÍTICO</option>
            <option value="ATENCAO"  ${filPrio==='ATENCAO'?'selected':''}>ATENÇÃO</option>
            <option value="EM_ROTA"  ${filPrio==='EM_ROTA'?'selected':''}>EM ROTA</option>
            <option value="OK"       ${filPrio==='OK'?'selected':''}>OK</option>
          </select>
        </div>
        <div class="cg-filter" style="flex:1;min-width:240px">
          <label>Buscar</label>
          <input id="f-q" type="text" value="${escapeHtml(filQ)}" placeholder="Filial, cidade, UF, pagador, AWB, NF, atendente…" />
        </div>
        <div class="cg-filter">
          <label>&nbsp;</label>
          <button class="zzy-btn zzy-btn--ghost" onclick="window.__reloadFiliais()" style="padding:8px 14px">↻</button>
        </div>
        <div class="cg-filter">
          <label>&nbsp;</label>
          <button class="zzy-btn zzy-btn--ghost" onclick="window.__exportFiliaisCsv()" style="padding:8px 14px">CSV</button>
        </div>
      </div>
    </div>
    <div class="zzy-card" style="padding:0;overflow:auto;max-height:calc(100vh - 380px)">
      <table class="cg-table">
        <thead><tr>
          <th>Prio</th><th>Filial</th><th>AWB/CTe</th><th>NF</th><th>Pagador</th><th>Destinatário</th>
          <th>Cidade/UF</th><th>Atendente</th>
          <th>Data Frete</th><th>Previsão</th><th>Status</th><th>Dias</th><th>Última Ocor</th>
        </tr></thead>
        <tbody>
          ${rows.length ? rows.slice(0, 500).map(r => {
            const prio = r.prioridade || 'OK';
            const prioCol = { CRITICO:'#EF4444', ATENCAO:'#F59E0B', EM_ROTA:'#3B6EFF', OK:'#22C55E' }[prio] || '#8C9BD1';
            const statusCol = isVencido(r) ? 'var(--zzy-danger)' : 'var(--zzy-text-mute)';
            return `<tr>
              <td><span style="color:${prioCol};font-weight:700;font-size:14px">●</span><br><small style="color:var(--zzy-text-mute);font-size:9px">${escapeHtml(prio)}</small></td>
              <td><strong>${escapeHtml(filialOf(r))}</strong></td>
              <td><strong>${escapeHtml(r.awb || '—')}</strong>${r.cte_terceiro ? `<br><small style="color:var(--zzy-text-mute)">3º ${escapeHtml(r.cte_terceiro)}</small>` : ''}</td>
              <td><strong style="color:var(--zzy-warning)">${escapeHtml(r.nf_cliente || '—')}</strong></td>
              <td title="${escapeHtml(r.pagador || '')}" style="max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${escapeHtml(r.pagador || '—')}</td>
              <td title="${escapeHtml(r.destinatario || '')}" style="max-width:140px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${escapeHtml(r.destinatario || '—')}</td>
              <td>${escapeHtml(r.destino_cidade || '—')}/${escapeHtml(r.destino_uf || '')}</td>
              <td>${escapeHtml(r.atendente || '—')}</td>
              <td>${fmtDate(r.data_frete_icaro)}</td>
              <td>${fmtDate(r.previsao_entrega)}</td>
              <td><span style="color:${statusCol};text-transform:uppercase;font-weight:600;font-size:11px">${escapeHtml(r.status_previsao || r.status || '—')}</span><br><small style="color:var(--zzy-text-mute);font-size:10px">${r.em_rota === 'SIM' ? '→ em rota' : ''}</small></td>
              <td>${r.dias_vencido > 0 ? `<span style="color:var(--zzy-danger);font-weight:600">+${r.dias_vencido}d</span>` : (r.dias_em_aberto || 0) + 'd'}</td>
              <td><small>${escapeHtml((r.status_descricao || '').slice(0, 50))}</small></td>
            </tr>`;
          }).join('') : '<tr><td colspan="13"><zzy-empty title="Nenhuma carga em aberto"></zzy-empty></td></tr>'}
        </tbody>
      </table>
    </div>
    <div style="margin-top:8px;font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);text-align:right">
      ${rows.length > 500 ? `Mostrando 500 de ${fmtBR(rows.length)}` : `${fmtBR(rows.length)} resultados`}
    </div>
  `;
  $('#f-filial')?.addEventListener('change', renderFiliais);
  $('#f-prio')?.addEventListener('change', renderFiliais);
  $('#f-q')?.addEventListener('input', () => clearTimeout(window.__qT) || (window.__qT = setTimeout(renderFiliais, 250)));
}
window.__reloadFiliais = loadFiliais;
window.__exportFiliaisCsv = () => downloadCsv(_allFiliais, 'filiais_' + new Date().toISOString().slice(0,10) + '.csv');

// ============================================================
// ABA · DASH FILIAL — KPIs por filial (resumo)
// ============================================================
async function loadDashFilial() {
  $('#content').innerHTML = `<zzy-spinner>Carregando dashboard filial…</zzy-spinner>`;
  try {
    const otd = await fetchJson('/vw_otd_por_filial?select=*&limit=50');
    if (!otd.length) {
      $('#content').innerHTML = `<div class="zzy-card"><zzy-empty title="Sem dados OTD"></zzy-empty></div>`;
      return;
    }
    // Separa em 2 segmentos (regra de negócio: WHP/BUD/MLOG fica segregado)
    const core = otd.filter(r => r.segmento === 'CORE')
      .sort((a, b) => (b.total_fretes || 0) - (a.total_fretes || 0));
    const segregado = otd.filter(r => r.segmento === 'WHP_BUD_MLOG')
      .sort((a, b) => (b.total_fretes || 0) - (a.total_fretes || 0));

    const totals = (rows) => rows.reduce((acc, r) => ({
      total: acc.total + (r.total_fretes || 0),
      noPrazo: acc.noPrazo + (r.no_prazo || 0),
      atrasados: acc.atrasados + (r.atrasados || 0),
      pendentes: acc.pendentes + (r.pendentes || 0),
      receita: acc.receita + (parseFloat(r.receita_total) || 0)
    }), { total: 0, noPrazo: 0, atrasados: 0, pendentes: 0, receita: 0 });

    const tCore = totals(core);
    const tSeg  = totals(segregado);
    const otdCore = tCore.total > 0 ? (100 * tCore.noPrazo / (tCore.noPrazo + tCore.atrasados)) : 0;
    const otdSeg  = tSeg.total > 0 ? (100 * tSeg.noPrazo / (tSeg.noPrazo + tSeg.atrasados)) : 0;

    const renderTable = (rows, totals, otdAgg, label, color) => `
      <div class="zzy-card" style="margin-bottom:16px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:12px">
          <h3 class="zzy-h3" style="margin:0;color:${color}">${label}</h3>
          <div style="display:flex;gap:14px;font-size:12px;color:var(--zzy-text-mute)">
            <span>Total: <strong style="color:var(--zzy-mist)">${fmtBR(totals.total)}</strong></span>
            <span>No prazo: <strong style="color:var(--zzy-success)">${fmtBR(totals.noPrazo)}</strong></span>
            <span>Atrasados: <strong style="color:var(--zzy-danger)">${fmtBR(totals.atrasados)}</strong></span>
            <span>OTD: <strong style="color:${otdAgg >= 90 ? 'var(--zzy-success)' : otdAgg >= 70 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'}">${otdAgg.toFixed(1).replace('.',',')}%</strong></span>
            <span>Receita: <strong style="color:var(--zzy-mist)">${fmtBRL(totals.receita)}</strong></span>
          </div>
        </div>
        <div style="overflow:auto">
        <table class="cg-table">
          <thead><tr>
            <th>Filial</th><th>Total</th><th>No prazo</th><th>Atrasados</th><th>Pendentes</th><th>OTD %</th><th>Receita</th>
          </tr></thead>
          <tbody>
            ${rows.map(r => `
              <tr>
                <td><strong>${escapeHtml(r.filial || '—')}</strong></td>
                <td>${fmtBR(r.total_fretes)}</td>
                <td>${fmtBR(r.no_prazo)}</td>
                <td><span style="color:var(--zzy-danger)">${fmtBR(r.atrasados)}</span></td>
                <td><span style="color:var(--zzy-warning)">${fmtBR(r.pendentes)}</span></td>
                <td><strong style="color:${(r.otd_pct||0) >= 90 ? 'var(--zzy-success)' : (r.otd_pct||0) >= 70 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'}">${(parseFloat(r.otd_pct)||0).toFixed(1).replace('.',',')}%</strong></td>
                <td>${fmtBRL(r.receita_total)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        </div>
      </div>
    `;

    const cgStat = `
      <div class="cg-stat">
        <zzy-stat-card label="Total fretes" value="${fmtBR(tCore.total + tSeg.total)}" color="primary" sub="${fmtBR(core.length + segregado.length)} linhas"></zzy-stat-card>
        <zzy-stat-card label="No prazo" value="${fmtBR(tCore.noPrazo + tSeg.noPrazo)}" color="success"></zzy-stat-card>
        <zzy-stat-card label="Atrasados" value="${fmtBR(tCore.atrasados + tSeg.atrasados)}" color="danger"></zzy-stat-card>
        <zzy-stat-card label="Pendentes" value="${fmtBR(tCore.pendentes + tSeg.pendentes)}" color="warning"></zzy-stat-card>
        <zzy-stat-card label="OTD geral" value="${(((tCore.noPrazo + tSeg.noPrazo) / Math.max(1, tCore.noPrazo + tSeg.noPrazo + tCore.atrasados + tSeg.atrasados)) * 100).toFixed(1).replace('.',',')}%" color="info"></zzy-stat-card>
      </div>
    `;

    $('#content').innerHTML = `
      <div style="margin-bottom:8px;font:400 12px/1.4 var(--zzy-font);color:var(--zzy-text-mute)">
        OTD por Filial — últimos 7 dias · regra de negócio: WHP/BUD/MLOG segregado dos consolidados (exceto Whirlpool USP)
      </div>
      ${cgStat}
      ${core.length ? renderTable(core, tCore, otdCore, '🔵 GERAL · CORE (exceto WHP/BUD/MLOG)', 'var(--zzy-sky)') : ''}
      ${segregado.length ? renderTable(segregado, tSeg, otdSeg, '🟠 SEGREGADO · WHP + BUD + MLOG', 'var(--zzy-warning)') : ''}
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · WHP — Whirlpool/BUD/MLOG segregado
// ============================================================
async function loadWHP() {
  $('#content').innerHTML = `<zzy-spinner>Carregando WHP/BUD/MLOG (regra: segregado, exceto Whirlpool USP)…</zzy-spinner>`;
  try {
    // Pagadores que entram no segregado (exceto USP)
    const PATTERNS = ['WHIRLPOOL', 'BUD', 'MLOG', 'KOMLOG'];
    const isWhpBud = (p) => {
      if (!p) return false;
      const up = p.toUpperCase();
      if (up.includes('USP')) return false;  // WHIRLPOOL USP é exceção
      return PATTERNS.some(pat => up.includes(pat));
    };
    const rows = await fetchJson('/vw_radar_atendente?select=awb,nf_cliente,cte_terceiro,pagador,destinatario,destino_cidade,destino_uf,quem_entrega_real,agente_entrega,data_frete_icaro,previsao_entrega,status_previsao,status_descricao,dias_vencido,em_rota,prioridade,atendente&or=(pagador.ilike.*WHIRLPOOL*,pagador.ilike.*BUD*,pagador.ilike.*MLOG*,pagador.ilike.*KOMLOG*)&limit=5000');
    const filtered = rows.filter(r => isWhpBud(r.pagador));
    const filialOf = r => r.quem_entrega_real || r.agente_entrega || '(sem filial)';
    const isVencido = r => r.status_previsao === 'VENCIDO' || (r.dias_vencido || 0) > 0;
    const byBrand = filtered.reduce((acc, r) => {
      const up = (r.pagador || '').toUpperCase();
      let brand = 'OUTROS';
      if (up.includes('WHIRLPOOL')) brand = 'WHIRLPOOL';
      else if (up.includes('BUD')) brand = 'BUD';
      else if (up.includes('MLOG')) brand = 'MLOG';
      else if (up.includes('KOMLOG')) brand = 'KOMLOG';
      (acc[brand] = acc[brand] || []).push(r);
      return acc;
    }, {});
    const total = filtered.length;
    const vencidos = filtered.filter(isVencido).length;
    const emRota = filtered.filter(r => r.em_rota === 'SIM').length;

    $('#content').innerHTML = `
      <div class="zzy-card" style="margin-bottom:16px;background:linear-gradient(135deg,rgba(245,158,11,.08),rgba(239,68,68,.10))">
        <div class="zzy-eyebrow" style="margin-bottom:6px;color:var(--zzy-warning)">Regra de negócio</div>
        <p style="color:var(--zzy-cloud);font-size:13px;margin:0">WHIRLPOOL · BUD · MLOG · KOMLOG são <strong>SEGREGADOS</strong> dos consolidados. <strong>Whirlpool USP é exceção</strong> e fica no GERAL.</p>
      </div>
      <div class="cg-stat">
        <zzy-stat-card label="Total segregado" value="${fmtBR(total)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Vencidos" value="${fmtBR(vencidos)}" color="danger"></zzy-stat-card>
        <zzy-stat-card label="Em rota" value="${fmtBR(emRota)}" color="info"></zzy-stat-card>
        ${Object.entries(byBrand).map(([brand, arr]) => `<zzy-stat-card label="${escapeHtml(brand)}" value="${fmtBR(arr.length)}" color="warning"></zzy-stat-card>`).join('')}
      </div>
      <div class="zzy-card" style="padding:0;overflow:auto;max-height:calc(100vh - 380px)">
        <table class="cg-table">
          <thead><tr>
            <th>Marca</th><th>Filial</th><th>AWB/CTe</th><th>NF</th><th>Pagador</th>
            <th>Destinatário</th><th>Cidade/UF</th><th>Atendente</th>
            <th>Previsão</th><th>Status</th><th>Dias</th>
          </tr></thead>
          <tbody>
            ${filtered.length ? filtered.slice(0, 500).map(r => {
              const up = (r.pagador || '').toUpperCase();
              let brand = '—';
              if (up.includes('WHIRLPOOL')) brand = 'WHP';
              else if (up.includes('BUD')) brand = 'BUD';
              else if (up.includes('MLOG')) brand = 'MLOG';
              else if (up.includes('KOMLOG')) brand = 'KOMLOG';
              return `<tr>
                <td><span class="cg-badge cg-badge--warn">${brand}</span></td>
                <td><strong>${escapeHtml(filialOf(r))}</strong></td>
                <td><strong>${escapeHtml(r.awb || '—')}</strong></td>
                <td><strong style="color:var(--zzy-warning)">${escapeHtml(r.nf_cliente || '—')}</strong></td>
                <td title="${escapeHtml(r.pagador || '')}" style="max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${escapeHtml(r.pagador || '—')}</td>
                <td>${escapeHtml((r.destinatario || '—').slice(0,25))}</td>
                <td>${escapeHtml(r.destino_cidade || '—')}/${escapeHtml(r.destino_uf || '')}</td>
                <td>${escapeHtml(r.atendente || '—')}</td>
                <td>${fmtDate(r.previsao_entrega)}</td>
                <td>${isVencido(r) ? '<span class="cg-badge cg-badge--late">VENCIDO</span>' : '<span class="cg-badge cg-badge--ok">OK</span>'}</td>
                <td>${(r.dias_vencido > 0) ? `+${r.dias_vencido}d` : '—'}</td>
              </tr>`;
            }).join('') : '<tr><td colspan="11"><zzy-empty title="Sem fretes WHP/BUD/MLOG em aberto"></zzy-empty></td></tr>'}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · BAIXAS — entregas finalizadas (mês corrente)
// ============================================================
async function loadBaixas() {
  $('#content').innerHTML = `<zzy-spinner>Carregando baixas do mês…</zzy-spinner>`;
  try {
    const hoje = new Date();
    const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().slice(0,10);
    const rows = await fetchJson(`/vw_baixas_completo?select=*&data_baixa=gte.${inicioMes}&order=delivered_at.desc&limit=20000`);
    const hojeStr = new Date().toLocaleDateString('en-CA');
    const qtdHoje = rows.filter(r => r.data_baixa === hojeStr).length;
    $('#content').innerHTML = `
      <div class="cg-stat">
        <zzy-stat-card label="Baixas hoje" value="${fmtBR(qtdHoje)}" color="success"></zzy-stat-card>
        <zzy-stat-card label="Baixas mês" value="${fmtBR(rows.length)}" color="primary"></zzy-stat-card>
      </div>
      <div class="zzy-card" style="padding:0;overflow:auto;max-height:calc(100vh - 280px)">
        <table class="cg-table">
          <thead><tr><th>Data baixa</th><th>Agente entrega</th><th>Cidade destino</th><th>Pagador</th><th>CT-e</th><th>NF</th><th>Volumes</th><th>Valor NF</th></tr></thead>
          <tbody>
            ${rows.length ? rows.slice(0, 500).map(r => `
              <tr>
                <td>${fmtDate(r.data_baixa)}</td>
                <td>${escapeHtml(r.agente_entrega || '—')}</td>
                <td>${escapeHtml(r.destino_cidade || '—')}</td>
                <td>${escapeHtml(r.pagador || '—')}</td>
                <td>${escapeHtml(r.document_number || '—')}</td>
                <td>${escapeHtml(r.nf_numero || '—')}</td>
                <td style="text-align:right">${fmtBR(r.volumes)}</td>
                <td style="text-align:right">${fmtBRL(r.valor_nf)}</td>
              </tr>
            `).join('') : '<tr><td colspan="8"><zzy-empty title="Sem baixas no mês"></zzy-empty></td></tr>'}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · CHEGANDO — inbound forecast por base agente
// ============================================================
async function loadChegando() {
  $('#content').innerHTML = `<zzy-spinner>Carregando inbound forecast…</zzy-spinner>`;
  try {
    const rows = await fetchJson('/vw_inbound_base?select=*&order=chegada_base_estimada.asc.nullslast&limit=5000');
    const hoje = new Date().toLocaleDateString('en-CA');
    const amanha = new Date(Date.now()+86400000).toLocaleDateString('en-CA');
    const qtdHoje    = rows.filter(r => r.chegada_base_estimada === hoje).length;
    const qtdAmanha  = rows.filter(r => r.chegada_base_estimada === amanha).length;
    const atrasados  = rows.filter(r => r.status_chegada === 'deveria_ter_chegado').length;
    // Stats por base
    const porBase = rows.reduce((acc, r) => { acc[r.base_destino] = (acc[r.base_destino] || 0) + 1; return acc; }, {});
    const basesOrdered = Object.entries(porBase).sort((a, b) => b[1] - a[1]);

    $('#content').innerHTML = `
      <div class="cg-stat">
        <zzy-stat-card label="Total em trânsito" value="${fmtBR(rows.length)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Chega hoje" value="${fmtBR(qtdHoje)}" color="info"></zzy-stat-card>
        <zzy-stat-card label="Chega amanhã" value="${fmtBR(qtdAmanha)}" color="info"></zzy-stat-card>
        <zzy-stat-card label="Já passou do prazo" value="${fmtBR(atrasados)}" color="danger"></zzy-stat-card>
      </div>
      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">Por base destino</h3>
        <div style="display:grid;grid-template-columns:repeat(auto-fit, minmax(180px, 1fr));gap:12px">
          ${basesOrdered.map(([base, n]) => `
            <div style="padding:14px;background:rgba(255,255,255,.03);border:1px solid var(--zzy-border);border-radius:8px">
              <div style="font:500 11px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">${escapeHtml(base)}</div>
              <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-mist)">${fmtBR(n)}</div>
            </div>
          `).join('')}
        </div>
      </div>
      <div class="zzy-card" style="padding:0;overflow:auto;max-height:calc(100vh - 460px)">
        <table class="cg-table">
          <thead><tr><th>Chegada</th><th>Status</th><th>Base</th><th>CT-e</th><th>NF</th><th>Pagador</th><th>Cidade destino</th></tr></thead>
          <tbody>
            ${rows.length ? rows.slice(0, 500).map(r => {
              const colors = { entregue:'#22C55E', deveria_ter_chegado:'#EF4444', chega_hoje:'#F59E0B', chega_amanha:'#3B6EFF', futuro:'#8C9BD1' };
              const labels = { entregue:'ENTREGUE', deveria_ter_chegado:'ATRASADO', chega_hoje:'HOJE', chega_amanha:'AMANHÃ', futuro:'FUTURO' };
              const c = colors[r.status_chegada] || '#8C9BD1';
              return `
                <tr>
                  <td>${fmtDate(r.chegada_base_estimada)}</td>
                  <td><span style="background:${c}22;color:${c};padding:2px 8px;border-radius:4px;font-size:10px;font-weight:700;text-transform:uppercase">${labels[r.status_chegada] || '?'}</span></td>
                  <td>${escapeHtml(r.base_destino || '—')}</td>
                  <td>${escapeHtml(r.cte || '—')}</td>
                  <td>${escapeHtml(r.nf || '—')}</td>
                  <td title="${escapeHtml(r.pagador || '')}" style="max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${escapeHtml(r.pagador || '—')}</td>
                  <td>${escapeHtml(r.cidade_destino || '—')}</td>
                </tr>
              `;
            }).join('') : '<tr><td colspan="7"><zzy-empty title="Nada chegando"></zzy-empty></td></tr>'}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · ROTAS SP — composição veículo + rentabilidade
// ============================================================
async function loadRotasSP() {
  $('#content').innerHTML = `<zzy-spinner>Carregando rotas SP…</zzy-spinner>`;
  try {
    const rows = await fetchJson('/vw_briefing_hotspots?select=*&limit=200');
    $('#content').innerHTML = `
      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 4px 0">Hotspots SP — regiões críticas</h3>
        <p style="color:var(--zzy-text-mute);font-size:13px;margin:0 0 16px 0">Top regiões com maior concentração de CT-es vencidos. Recomendação inclui composição de mega-rotas.</p>
        ${rows.length ? `
          <table class="cg-table">
            <thead><tr><th>#</th><th>CEP5</th><th>Cidade</th><th>Bairro</th><th>Região</th><th>Total</th><th>Vencidos</th><th>Pagadores</th><th>Score</th><th>Recom.</th></tr></thead>
            <tbody>
              ${rows.map(r => `
                <tr>
                  <td><strong style="color:var(--zzy-sky)">#${r.rank_rota}</strong></td>
                  <td><code class="zzy-mono">${escapeHtml(r.cep5 || '')}</code></td>
                  <td>${escapeHtml(r.cidade || '')}</td>
                  <td>${escapeHtml(r.bairro || '')}</td>
                  <td>${escapeHtml(r.regiao || '')}</td>
                  <td>${fmtBR(r.total_ctes)}</td>
                  <td style="color:var(--zzy-danger)"><strong>${fmtBR(r.vencidos)}</strong></td>
                  <td style="font-size:11px;color:var(--zzy-text-mute)">${escapeHtml(r.pagadores || '')}</td>
                  <td>${fmtBR(r.score_prioridade)}</td>
                  <td><span class="cg-badge cg-badge--warn">${escapeHtml(r.recomendacao || '')}</span></td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        ` : '<zzy-empty title="Sem hotspots"></zzy-empty>'}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

bootstrap();
